import React from 'react';
import HandBookImage from '../../../../assets/images/handbook.jpg';

import HandbookConfirmationImg from '../../../../assets/handbook_confirmation_image.png';
import HandbookConfirmationPdf from '../../../../assets/handbook_confirmation.pdf';
import resourceBookletImage from '../../../../assets/resourceBookletImage.png';
import resourceBookletImagePdf from '../../../../assets/resourceBookletPdf.pdf';
import nynorskDyslexiaConfimationImage from '../../../../assets/nynorsk-dyslexia-confimation.jpg';
import nynorskDyslexiaConfimationPdf from '../../../../assets/nynorsk-dyslexia-confimation.pdf';

import {Link} from 'react-router-dom';
import handBookPdf from 'assets/DysmateHåndbok_v1.1_compressed.pdf';
import dysmate2HandBookPdf from 'assets/Dysmate2_compressed.pdf';
import dysmate2HandBookImage from 'assets/Dysmate-image.png';
import dysmateAImage from 'assets/Skjermbilde-A.png';
import dysmateAPdf from 'assets/Dysmate-A_compressed.pdf';
import dysmateCImage from 'assets/Skjermbilde-C.png';
import dysmateCPdf from 'assets/Dysmate-C_compressed.pdf';
import dysmateYImage from 'assets/Skjermbilde-Y.png';
import dysmateYPdf from 'assets/Dysmate-Y_compressed.pdf';

import './styles.scss';
import strings from 'utils/strings';

class HandBook extends React.Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		const hasLocation =
			this.props.location !== 'undefined' ? this.props.location : null;

		const hasPathName = hasLocation ? hasLocation.pathname : null;
		const isLibraryPath =
			hasLocation && this.props.location.pathname === '/bibliotek'
				? true
				: null;
		return (
			<div
				className={
					!isLibraryPath
						? 'lit-handbook-main'
						: 'lit-handbook-main_library-style'
				}
			>
				{hasPathName ? (
					<h1 className="lit-handbook-title">
						{strings.formatString(strings.handbooktitle, <></>)}
					</h1>
				) : (
					<></>
				)}
				{!isLibraryPath && this.props.useDysmate2Handbook && (
					<>
						<span>
							<a href={dysmate2HandBookPdf} target="_blank">
								<img
									className="lit-handbook-img"
									src={dysmate2HandBookImage}
								/>
							</a>
						</span>
						<span className="lit-handbook-title-link">
							<Link
								to={dysmate2HandBookPdf}
								target="_blank"
								rel="noopener noreferrer"
							>
								Dysmate-2 Håndbok
							</Link>
						</span>
					</>
				)}
				{!isLibraryPath && !this.props.useDysmate2Handbook && (
					<>
						<span>
							<a href={handBookPdf} target="_blank">
								<img
									className="lit-handbook-img"
									src={HandBookImage}
								/>
							</a>
						</span>
						<span className="lit-handbook-title-link">
							<Link
								to={handBookPdf}
								target="_blank"
								rel="noopener noreferrer"
							>
									{strings.handbookDysmateLink}
								</Link>
						</span>
					</>
				)}

				{isLibraryPath && (
					<div className="lit-library-content-wrapper">
						<div className="lit-library-content-wrapper__row">
							<a href={dysmate2HandBookPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={dysmate2HandBookImage}
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={dysmate2HandBookPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Dysmate-2 Håndbok
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={dysmateAPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={dysmateAImage}
									alt="Dysmate-A"
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={dysmateAPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Dysmate-A
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={dysmateCPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={dysmateCImage}
									alt="Dysmate-C"
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={dysmateCPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Dysmate-C
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={dysmateYPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={dysmateYImage}
									alt="Dysmate-Y"
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={dysmateYPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Dysmate-Y
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={handBookPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={HandBookImage}
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={handBookPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									{strings.handbookDysmateLink}
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={HandbookConfirmationPdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={HandbookConfirmationImg}
								/>
							</a>

							<div className="lit-lib-handbook-title-link">
								<Link
									to={HandbookConfirmationPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									{strings.dyslexiaConfirmationLink}
								</Link>
							</div>
						</div>
						<div className="lit-library-content-wrapper__row">
							<a href={resourceBookletImagePdf} target="_blank">
								<img
									className="lit-lib-handbook-img"
									src={resourceBookletImage}
								/>
							</a>
							<div className="lit-lib-handbook-title-link">
								<Link
									to={resourceBookletImagePdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									{strings.resourceBookletDysmateLink}
								</Link>
							</div>
						</div>

						<div className="lit-library-content-wrapper__row">
							<a
								href={nynorskDyslexiaConfimationPdf}
								target="_blank"
							>
								<img
									className="lit-lib-handbook-img"
									src={nynorskDyslexiaConfimationImage}
								/>
							</a>
							<div className="lit-lib-handbook-title-link">
								<Link
									to={nynorskDyslexiaConfimationPdf}
									target="_blank"
									rel="noopener noreferrer"
								>
									Stadfesting av dysleksi
								</Link>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}
export default HandBook;
